import {
  facilityLabel as sharedFacilityLabel,
  manifestNumberLabel as sharedManifestNumberLabel,
} from "encamp-shared/src/waste/shippingDocumentLabels";
import { ShippingDocumentKind } from "generated-graphql/graphql";

import { type ManifestReviewRow } from "./api";

export function isBillOfLadingRow(row: Pick<ManifestReviewRow, "documentKind">): boolean {
  return row.documentKind === ShippingDocumentKind.BillOfLading;
}

export function manifestNumberLabel(
  row: Pick<ManifestReviewRow, "documentKind" | "manifestTrackingNumber">
): string {
  return sharedManifestNumberLabel(row);
}

export function facilityLabel(
  row: Pick<ManifestReviewRow, "documentKind" | "facilityId" | "facilityName" | "facilityEpaId">
): string {
  return sharedFacilityLabel(row, row.facilityEpaId ?? "—");
}
